// Anonymous pageview beacon. One localStorage-scoped UUID per browser
// (session_id), fired once per public-page mount. Sends to the backend
// /api/analytics/pageview endpoint. No auth, no PII, no cookies.

import { api } from "@/lib/api";

function getSessionId() {
  try {
    let s = window.localStorage.getItem("ao_session_id");
    if (!s) {
      s =
        (crypto?.randomUUID && crypto.randomUUID()) ||
        Math.random().toString(36).slice(2) + Date.now().toString(36);
      window.localStorage.setItem("ao_session_id", s);
    }
    return s;
  } catch {
    return "no-storage";
  }
}

export function trackPageview(path) {
  try {
    api
      .post("/analytics/pageview", {
        session_id: getSessionId(),
        path: path || window.location.pathname,
        referrer: document.referrer || "",
        user_agent: (navigator.userAgent || "").slice(0, 160),
      })
      .catch(() => {});
  } catch {
    // fire-and-forget; never break the page for analytics
  }
}


// Flyer share-click beacon. Fire-and-forget; never blocks the share itself.
// `channel` must be one of the values whitelisted by the backend:
//   whatsapp, sms, email, twitter, facebook, linkedin, native, copy,
//   pdf-download, png-square, png-story.
export function trackShareClick(channel, opts = {}) {
  try {
    const body = JSON.stringify({
      channel,
      ref: opts.ref || "AZIZ-2026",
      source: opts.source || "operator_landing",
    });
    const url = `${api.defaults.baseURL}/analytics/share-click`;
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    } else {
      api.post("/analytics/share-click", JSON.parse(body)).catch(() => {});
    }
  } catch {
    // swallow — never break the share
  }
}

